import React, { useState } from 'react';
import './Contact.css';
import { Copy, Check, Sparkles } from 'lucide-react';

// Custom LinkedIn SVG Icon since brand icons are not exported in this version of lucide-react
const Linkedin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
    <rect x="2" y="9" width="4" height="12" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);


const Contact = () => {
  const [copied, setCopied] = useState(false);
  const emailAddress = 'antocuti3d@gmail.com';

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(emailAddress);
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">

        {/* Header della sezione */}
        <div className="contact-header">
          <div className="contact-tag">
            <Sparkles size={16} className="text-purple-accent" />
            <span>Get in Touch</span>
          </div>
          <h2 className="contact-title">
            Wanna work <span className="text-purple-gradient">with me?</span>
          </h2>
          <p className="contact-subtitle">
            I'm always open to discussing new projects, creative ideas, or opportunities in the 3D space.
          </p>
        </div>

        {/* Card Contatti (Glassmorphic) */}
        <div className="contact-card">
          <div className="contact-glow-effect"></div>

          <div className="contact-card-content">
            {/* Sezione Mail con pulsante Copia */}
            <div className="email-wrapper">
              <div className="email-info">
                <span className="email-label">Professional Email</span>
                <span className="email-value">{emailAddress}</span>
              </div>
              <button
                onClick={handleCopy}
                className={`copy-button ${copied ? 'copied' : ''}`}
                aria-label="Copy email address"
              >
                {copied ? (
                  <>
                    <Check size={18} className="copy-icon text-green-accent" />
                    <span>Copied!</span>
                  </>
                ) : (
                  <>
                    <Copy size={18} className="copy-icon" />
                    <span>Copy Mail</span>
                  </>
                )}
              </button>
            </div>

            {/* Divisore */}
            <div className="contact-divider"></div>

            {/* Sezione Social Link */}
            <div className="social-links-container">
              <span className="social-label">Find me on</span>
              <div className="social-grid">

                {/* LinkedIn */}
                <a
                  href="https://www.linkedin.com/in/antoninocuti/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link-item"
                >
                  <div className="social-icon-wrapper linkedin-color">
                    <Linkedin size={20} />
                  </div>
                  <div className="social-info">
                    <h4>LinkedIn</h4>
                    <p>Connect professionally</p>
                  </div>
                </a>



              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default Contact;
